import { createAction, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'index';
import { resetStore } from 'rdx/modules/app/slice';
import { GenericActionPayload } from 'types/redux-types';
import { LicenseAttributes } from 'types/licenses';
import ResourceList from 'lib/jsonApi/ResourceList';

type LicensesState = {
  licenses: ResourceList<LicenseAttributes>;
  licenseQuoteURL: string;
};

const initialState: LicensesState = {
  licenses: new ResourceList(),
  licenseQuoteURL: '',
};

const requestLicenses = createAction<GenericActionPayload>('requestLicenses');
const requestLicenseQuoteURL = createAction<GenericActionPayload>('requestLicenseQuoteURL');

const licensesSlice = createSlice({
  name: 'licenses',
  initialState,
  reducers: {
    setLicenses: (state, action: PayloadAction<ResourceList<LicenseAttributes>>) => {
      state.licenses = action.payload;
    },
    setLicenseQuoteURL: (state, action: PayloadAction<string>) => {
      state.licenseQuoteURL = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore.type, () => initialState);
  },
});

const {
  setLicenses,
  setLicenseQuoteURL,
} = licensesSlice.actions;

export {
  requestLicenses,
  requestLicenseQuoteURL,
  setLicenses,
  setLicenseQuoteURL,
};

export const getLicenses = (state: RootState) => state.licenses.licenses;
export const getLicenseQuoteURL = (state: RootState) => state.licenses.licenseQuoteURL;

export default licensesSlice.reducer;
